module.exports = __webpack_public_path__ + "img/weixin.36b47d08.jpg";